module.exports = __webpack_public_path__ + "static/media/full-programme.24178ff6.svg";